import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import MarkdownRenderer from "../../MarkdownRenderer";
import styles from "./intent-classifier.module.scss";

type DataTalkIntentClassifierAgentProps = {
    parsedContent: any;
};

export default function DataTalkIntentClassifierAgent({
    parsedContent,
}: DataTalkIntentClassifierAgentProps): JSX.Element {
    const answer = safeJSONParse(parsedContent?.finalAnswer);
    const question = parsedContent?.question;
    const responseData = answer;

    console.log("Intent", answer);

    // Handle case where no response data is available
    if (!responseData) {
        return (
            <div className={styles.classifierContainer}>
                <div className={styles.emptyState}>
                    <p>No classification data available.</p>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.classifierContainer}>

            {/* Clarification Section */}
            {responseData?.clarification && (
                <div className={styles.clarificationSection}>
                    <h5 className={styles.clarificationTitle}>
                        Clarification Needed
                    </h5>

                    {/* Clarification Question */}
                    {responseData.clarification.question && (
                        <div className={styles.questionBox}>
                            <MarkdownRenderer content={responseData.clarification.question} />
                        </div>
                    )}


                    {/* Options (if available) */}
                    {responseData.clarification.options &&
                        responseData.clarification.options.length > 0 && (
                            <div className={styles.optionsSection}>
                                <div className={styles.sectionLabel}>
                                    Available Options
                                </div>
                                <ul className={styles.optionsList}>
                                    {responseData.clarification.options.map(
                                        (option: string, idx: number) => (
                                            <li key={idx}>{option}</li>
                                        )
                                    )}
                                </ul>
                            </div>
                        )}
                </div>
            )}

            {/* Final Question */}
            {question && (
                <div className={styles.finalQuestionSection}>
                    <div className={styles.questionLabel}>Question</div>
                    <p className={styles.questionText}>{question}</p>
                </div>
            )}
        </div>
    );
}
